import React, { Component } from 'react';
import $ from "jquery";
import axios from 'axios';
class ContactInformation extends Component {
  constructor() {
    super();
    this.state = {
      submit_button:<button className="btn btn-primary w-100 py-3" type="button" onClick={this.add_emp_basic_details.bind(this)}>Update</button>,
    };
  }


  componentDidMount(){
    this.get_emp_basic_details();
  }
  get_emp_basic_details(){
      var cutThis           = this;
      var emp_id            = cutThis.props.id;
      var web_token         = window.isNullAndUndef($('#web_token').val());
      var body = new FormData();
      body.append('emp_id',emp_id);
      body.append('web_token',web_token);
      body.append('form_type','employee_contact_information');
      body.append('function','get_emp_basic_details');
      var url      = '';
      if(window.location.host ==="localhost:3000"){
        url = "http://localhost/bylawsindia/php/admin_employee_management_url.php";
      }else{
        url = "/php/admin_employee_management_url.php";
      }
      axios({
           method: 'POST',
           url: url,
           data: body
       })
       .then(function (res) {
          var data = res.data;
          if(data['error']==1){
            var new_data = data['data'];
            cutThis.update_info(new_data);
          }

       })
       .catch(function (error) {
           console.log(error);
       });
  }

  update_info(data){
    $('#current_address ').val(data['current_address']);
    $('#permanent_address').val(data['permanent_address']);
    $('#mobile_no').val(data['mobile_no']);
    $('#email').val(data['email']);
    $('#contact_number').val(data['contact_number']);
  }

  add_emp_basic_details(){
    var cutThis           = this;
    var emp_id            = cutThis.props.id;
    var web_token         = window.isNullAndUndef($('#web_token').val());
    var current_address   = window.isNullAndUndef($('#current_address').val());
    var permanent_address = window.isNullAndUndef($('#permanent_address').val());
    var mobile_no         = window.isNullAndUndef($('#mobile_no').val());
    var email             = window.isNullAndUndef($('#email').val());
    var contact_number    = window.isNullAndUndef($('#contact_number').val());
    var submit_button     = <button className="btn btn-primary w-100 py-3" type="button">Update...</button>;
    cutThis.setState({submit_button});
    $('label').removeClass('color_red');
    if(current_address && permanent_address && mobile_no && email && contact_number){
      var all_data                    = {};
      all_data['current_address']     = current_address;
      all_data['permanent_address']   = permanent_address;
      all_data['mobile_no']           = mobile_no;
      all_data['email']               = email;
      all_data['contact_number']      = contact_number;
      var body = new FormData();
      body.append('emp_id',emp_id);
      body.append('emp_date',JSON.stringify(all_data));
      body.append('web_token',web_token);
      body.append('form_type','employee_contact_information');
      body.append('function','add_emp_basic_details');
      var url      = '';
      if(window.location.host ==="localhost:3000"){
        url = "http://localhost/bylawsindia/php/admin_employee_management_url.php";
      }else{
        url = "/php/admin_employee_management_url.php";
      }
      axios({
           method: 'POST',
           url: url,
           data: body
       })
       .then(function (res) {
          var data = res.data;
          console.log(data);
          $('#error_msg').text(data['msg']);
          submit_button     = <button className="btn btn-primary w-100 py-3" type="button" onClick={cutThis.add_emp_basic_details.bind(cutThis)}>Update</button>;
          cutThis.setState({submit_button});
       })
       .catch(function (error) {
           console.log(error);
       });
    }else {
      window.change_lable_color('current_address','permanent_address','mobile_no','email','contact_number');
      submit_button     = <button className="btn btn-primary w-100 py-3" type="button" onClick={cutThis.add_emp_basic_details.bind(cutThis)}>Update</button>;
      cutThis.setState({submit_button});
    }

  }




  render() {
    return (
        <>
        	<div className="mt-4 mb-4">
                <h3 className="wow fadeInUp" data-wow-delay="0.1s">{this.props.page_title}</h3>
                <div className="row g-4">


                <div className="col-md-12">
                    <div className="wow fadeInUp" data-wow-delay="0.5s">
                        <form action="" method="post">
                            <div className="row g-3">

                                <div className="col-md-12">
                                    <div className="form-floating">
                                        <input type="text" className="form-control" id="current_address" placeholder="Current Residential Address"/>
                                        <label for="name">Current Residential Address</label>
                                    </div>
                                </div>
                                <div className="col-md-12">
                                    <div className="form-floating">
                                        <input type="text" className="form-control" id="permanent_address" placeholder="Permanent Address"/>
                                        <label for="name">Permanent Address</label>
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <div className="form-floating">
                                        <input type="text" className="form-control" id="mobile_no" placeholder="Personal Mobile Number"/>
                                        <label for="name">Personal Mobile Number</label>
                                    </div>
                                </div>

                                <div className="col-md-4">
                                    <div className="form-floating">
                                        <input type="text" className="form-control" id="email" placeholder="Personal Email ID"/>
                                        <label for="name">Personal Email ID</label>
                                    </div>
                                </div>

                                <div className="col-md-4">
                                    <div className="form-floating">
                                        <input type="text" className="form-control" id="contact_number" placeholder="Alternate Contact Number"/>
                                        <label for="name">Alternate Contact Number</label>
                                    </div>
                                </div>


                                <div className="col-md-12">
                                  <div className="col-md-8">
                                    <p id="error_msg"></p>
                                  </div>
                                    <div className="col-md-4 p-0 float_r">
                                        {this.state.submit_button}
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>

            </div>
        </div>

        </>
    );
  }
}

export default ContactInformation;
